import jwt_decode from "jwt-decode";
import Header from "../../../layout/header";
import PersonalDetails from "./PersonalDetails";
import ServiceDetails from "./Services";
import Spinner from "../../../components/Loader";
import FeedbackFlow from "../FeedBack";
import { useCallback, useEffect, useRef, useState } from "react";
import { GetVendorDetails } from "../../../store/apiCalls/profilesetup";
import { FetchVendorDetails } from "../../../containers/venderFlow/profileSetup/queries";
import { SERVER_URL } from "../../../config";
import "../../../assets/scss/modules/_layoutGlobal.scss";
import "../../../assets/scss/personal_detail.scss";
import "../../../assets/scss/components/_formsGlobal.scss";
import "../../../assets/scss/components/_buttonsGlobal.scss";
import "../../../assets/scss/base/themecomponents/_resetGlobal.scss";
import "../../../assets/font_icons/style.scss";
import profilePicture from "../../../assets/img/sample/profile.png";
import arrowLeft from "../../../assets/img/icons/arrow_left.svg";
import {
  handleChatBot,
  isPublishable,
  removeDuplicates,
  unPublishToolTip,
} from "../../../utils";
import { Link, useNavigate } from "react-router-dom";
import { getSkillsData } from "../../../store/apiCalls/profilesetup";
import { useDispatch } from "react-redux";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
};
const ProfilePreview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profileData, setProfileData] = useState({});
  const [activeTab, setActiveTab] = useState("PersonalDetails");
  const [showFeedbackModal, setShowFeedbackModal] = useState(initialState);
  const token = localStorage.getItem("vendorToken");
  // const [profilePublished, setProfilePublished] = useState(false);
  const { id } = jwt_decode(token ? token : "");
  const fetchSkills = async () => {
    const params = { id: id };
    const header = { Authorization: `Bearer ${token}` };
    const skillResp = await getSkillsData(params, header);
    if (skillResp.data.success) {
      dispatch({ type: "SET_SKILLS_DATA", payload: skillResp.data.data || [] });
    }
  };

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchdata = async () => {
    const params = { id: id };
    const header = { Authorization: `Bearer ${token}` };
    return GetVendorDetails(params, header);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    navigate("/profileSetup");
  };

  const isServiceApproved = () => {
    let publishNow = false;
    profileData.serviceId?.map((ser) => {
      const status = ser?.requestForOtherServiceId?.status || ser.serviceStatus;
      publishNow = publishNow ? publishNow : status === "Approve";
    });
    return publishNow;
  };

  const checkForApprovedServices = () => {
    const services = removeDuplicates(
      profileData?.serviceId?.map((a) => a.serviceOfferedId.serviceName)
    );
    return services.length > 1
      ? true
      : services[0] === "Others"
      ? isServiceApproved()
      : true;
  };

  const handleFeedback = (e) => {
    e.preventDefault();
    if (checkForApprovedServices()) {
      setShowFeedbackModal({
        ...initialState,
        showFeedbackModal: !profileData.feedbackDone,
        congratsPreview: profileData.feedbackDone,
      });
    } else {
      setShowFeedbackModal({ ...initialState, unPublish: true });
    }
  };

  const sucessHandlerVendor = (fetchedData) => {
    if (fetchedData.status === 200) {
      setProfileData(fetchedData.data.data);
    }
  };

  const { isLoading, refetch } = FetchVendorDetails(
    fetchdata,
    sucessHandlerVendor
  );

  if (isLoading) {
    return <Spinner loading={isLoading} />;
  }

  const isProfilePublishable = isPublishable(profileData);

  const handleFeedbackModalStat = (data, refetchData = false) => {
    if (refetchData) {
      refetch();
      setProfileData({ ...profileData, feedbackDone: refetchData });
    }
    setShowFeedbackModal(data);
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    localStorage.clear();
    // dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
    window.navigation.navigate(SERVER_URL);
  };

  return (
    <>
      <Header />
      {profileData.email && (
        <>
          <div className="mt-4">
            <div className="previewTitle">
              <div className="containWrap">
                <h1>Preview Profile</h1>
                <p>
                  Looking good {profileData.fullName}! Take this moment to make
                  any edits you want and publish your profile.You can always
                  make more changes even after it is live.
                </p>
              </div>
            </div>
            <div className="previewContent">
              <div className="containWrap">
                <div className="previewProfile">
                  <div
                    className={`previewProfile-img ${
                      profileData?.aboutId?.profilePicture ? "noBg" : ""
                    }`}
                  >
                    {" "}
                    {profileData?.aboutId?.profilePicture && (
                      <img src={profileData?.aboutId?.profilePicture} alt="#" />
                    )}
                  </div>
                  <div className="previewProfile-info">
                    <small>Graphics &amp; Designs</small>
                    <div>
                      <p>
                        <b className="icon-email" />
                        {profileData.email}
                      </p>
                      <p>
                        <b className="icon-call" />
                        {profileData.phoneNumber &&
                          `${profileData.phoneNumber}`}
                      </p>
                    </div>
                  </div>
                  {/* {!profilePublished ? ( */}
                    <div className="previewProfile-btn">
                      <a
                        href="/profileSetup"
                        onClick={handleCancel}
                        className="button button-ntv grey"
                      >
                        Cancel
                      </a>
                      <button
                        onClick={(e) => handleFeedback(e)}
                        className={`button button-primary ms-4`}
                        disabled={!isProfilePublishable}
                      >
                        Publish Profile
                      </button>
                    </div>
                  {/* ) : ( */}
                    {/* <div className="text-center">
                      <Link
                        to="/vendordashboard"
                        onClick={(e) => handleRedirect(e)}
                        className="link text-decoration-none f-700"
                      >
                        HOME
                      </Link>
                    </div> */}
                  {/* )} */}
                </div>
                <div className="simpleTabs">
                  <ul>
                    <li>
                      <a
                        onClick={() => setActiveTab("PersonalDetails")}
                        className={activeTab === "PersonalDetails" && "active"}
                      >
                        Personal Details
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setActiveTab("Services")}
                        className={activeTab === "Services" && "active"}
                      >
                        Services
                      </a>
                    </li>
                  </ul>
                </div>
                {activeTab === "Services" ? (
                  profileData.serviceId?.length > 0 ? (
                    profileData.serviceId?.map((service, index) => {
                      return (
                        <>
                          <ServiceDetails service={service} idx={index} />
                        </>
                      );
                    })
                  ) : (
                    <small>No Services added.</small>
                  )
                ) : (
                  <PersonalDetails data={profileData} />
                )}
                {/* {!profilePublished ? ( */}
                  <div className="text-center boxFooter">
                    <a onClick={handleCancel} className="goBack">
                      Back
                      <b>
                        <img src={arrowLeft} alt="#" />
                      </b>
                    </a>
                    <button
                      type="button"
                      className={`button button-primary ms-2`}
                      disabled={!isProfilePublishable}
                      toolTipMessage={
                        isProfilePublishable ? "" : unPublishToolTip
                      }
                      onClick={(e) => handleFeedback(e)}
                    >
                      Publish Profile
                    </button>
                  </div>
                {/* ) : ( */}
                  {/* <div className="text-center" style={{ margin: "20px 0" }}>
                    <Link
                      to="/vendordashboard"
                      onClick={(e) => handleRedirect(e)}
                      className="link text-decoration-none f-700"
                    >
                      HOME
                    </Link>
                  </div> */}
                {/* )} */}
              </div>
            </div>
          </div>
          <div>
            <div className="quickFAQ" onClick={(e) => handleChatBot(e)}>
              <div>
                <p>Questions?</p>
                <span>Talk to Us</span>
              </div>
            </div>
          </div>

          <FeedbackFlow
            handleModalClose={handleFeedbackModalStat}
            modalStat={showFeedbackModal}
            profileData={profileData}
            code={profileData.promoCode}
            // onProfilePublish={() => setProfilePublished(true)}
          />
        </>
      )}
    </>
  );
};

export default ProfilePreview;
